<template>
  <van-popup
    v-model="kaiguan"
    get-container="body"
    :style="{background:'transparent'}"
    :close-on-click-overlay="false"
  >
    <div class="show-games">
      <p class="title mt" v-if="from==='default'">优惠券可用游戏列表</p>
      <div v-else class="mt">
        <p class="title">请选择游戏</p>
        <p class="subhead">点击选择优惠券适用的游戏</p>
      </div>
      <van-row class="list mt2">
        <van-col
          span="8"
          v-for="item in games"
          :key="item.id"
          class="mt"
          @click.stop="changeGameID(item.id)"
        >
          <van-image width="1.8rem" height="1.8rem" fit="cover" :src="item.icon_url" class="mt1" />
          <p class="name">{{item.name}}</p>
          <i :class="[{inputSuccess:gameid === item.id,input:true}]"></i>
        </van-col>
      </van-row>
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="handleGetDiscount"
      >确定</van-button>
    </div>
    <div class="cancel" @click.stop="$parent.open('showGames')"></div>
  </van-popup>
</template>

<script>
export default {
  name: "ShowGames",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    prize: {
      type: Object,
      default: function() {
        return {};
      }
    },
    from: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    gamelist: [
      {
        name: "剑凌苍穹",
        id: 231,
        icon_url: "https://img.ldmnq.com/ldstore/aKdxaY-1565875598755.png"
      },
      {
        name: "王牌战争",
        id: 107,
        icon_url: "https://img.ldmnq.com/ldstore/NSScRE-1565355565931.png"
      },
      {
        name: "金币大富翁",
        id: 252,
        icon_url: "https://img.ldmnq.com/ldstore/WYxE7a-1562211028945.png"
      },
      {
        name: "剑与轮回",
        id: 302,
        icon_url:
          "https://img.ldmnq.com/ldstore/YB7QaMENxkkj4yJDj8ftxNsb7KpmPK5p.png"
      },
      {
        name: "精灵盛典",
        id: 351,
        icon_url: "https://img.ldmnq.com/ldstore/syTdYZ-1566180462440.png"
      },
      {
        name: "星云纪",
        id: 347,
        icon_url: "https://img.ldmnq.com/ldstore/J6Ej2x-1562067462919.png"
      },
      {
        name: "神魔幻想",
        id: 425,
        icon_url: "https://img.ldmnq.com/ldstore/dBFTWw-1566440694213.png"
      },
      {
        name: "征途2",
        id: 133,
        icon_url:
          "https://img.ldmnq.com/ldstore/WJQKb2jQwsypnnSm24iPxSmjAnSwn2x2.png"
      },
      {
        name: "命运卷轴",
        id: 378,
        icon_url: "https://img.ldmnq.com/ldstore/8DNG4D-1565247711208.png"
      },
      {
        name: "光明荣耀",
        id: 371,
        icon_url: "https://img.ldmnq.com/ldstore/wDJE7h-1564400801054.png"
      },
      {
        name: "九州飞凰录",
        id: 286,
        icon_url:
          "https://img.ldmnq.com/ldstore/j8kbGepKFH8PRYSGpwtwZC4fPwjCPwyx.png"
      },
      {
        name: "烈焰龙城",
        id: 159,
        icon_url:
          "https://img.ldmnq.com/ldstore/hcxHCDPMjckc23TjWxDB2rD6cJPcWSnd.png"
      },
      {
        name: "诛仙",
        id: 70,
        icon_url: "https://img.ldmnq.com/ldstore/zpS8dm-1565245508295.png"
      },
      {
        name: "剑与契约",
        id: 280,
        icon_url: "https://img.ldmnq.com/ldstore/GxzMJY-1565092431225.png"
      },
      {
        name: "诸王黎明",
        id: 389,
        icon_url: "https://img.ldmnq.com/ldstore/TkTzFS-1565252031234.png"
      },
      {
        name: "诛神记",
        id: 214,
        icon_url: "https://img.ldmnq.com/ldstore/4FjHFM-1565875432485.png"
      },
      {
        name: "远征手游",
        id: 219,
        icon_url: "https://img.ldmnq.com/ldstore/QjAGEw-1566785525877.png"
      },
      {
        name: "妖姬OL2",
        id: 276,
        icon_url:
          "https://img.ldmnq.com/ldstore/xXfHmztF7G7i3fBzBkQrh4nN28abXSDF.png"
      },
      {
        name: "小米枪战",
        id: 51,
        icon_url: "https://img.ldmnq.com/ldstore/ikDmX3-1565875473351.png"
      },
      {
        name: "我在江湖",
        id: 463,
        icon_url: "https://img.ldmnq.com/ldstore/nB5c72-1567080342392.png"
      },
      {
        name: "圣痕觉醒",
        id: 437,
        icon_url: "https://img.ldmnq.com/ldstore/cMdw6s-1567754503121.png"
      },
      {
        name: "三十六计",
        id: 170,
        icon_url: "https://img.ldmnq.com/ldstore/ks2irz-1565875552897.png"
      },
      {
        name: "三国列传",
        id: 478,
        icon_url: "https://img.ldmnq.com/ldstore/EHfcEc-1567997061198.png"
      },
      {
        name: "平妖传OL",
        id: 382,
        icon_url: "https://img.ldmnq.com/ldstore/KwXyDQ-1565701387276.png"
      },
      {
        name: "黎明之路",
        id: 297,
        icon_url:
          "https://img.ldmnq.com/ldstore/jy3DKDSp7yNysAe6bn44NQs5WGbY6QHn.png"
      },
      {
        name: "问道",
        id: 53,
        icon_url:
          "https://img.ldmnq.com/ldstore/E7xEFG2D2AQCw8kQCE5jwPeeKEy33jjz.png"
      },
      {
        name: "雷霆霸业",
        id: 235,
        icon_url: "https://img.ldmnq.com/ldstore/T7YjKy-1565875576600.png"
      },
      {
        name: "僵尸冲突2",
        id: 317,
        icon_url: "https://img.ldmnq.com/ldstore/3Rne42-1562833967915.png"
      },
      {
        name: "幻域战魂",
        id: 471,
        icon_url: "https://img.ldmnq.com/ldstore/XkHPmx-1567427929670.png"
      },
      {
        name: "战争之王",
        id: 476,
        icon_url: "https://img.ldmnq.com/ldstore/WxZWTW-1568196952520.png"
      },
      {
        name: "光明勇士",
        id: 208,
        icon_url:
          "https://img.ldmnq.com/ldstore/bstQfSZHHDNy2X3ceitEzXhEyXd46DNt.png"
      },
      {
        name: "封剑神录",
        id: 417,
        icon_url: "https://img.ldmnq.com/ldstore/DeZFy5-1567515500336.png"
      },
      {
        name: "废土行动",
        id: 266,
        icon_url: "https://img.ldmnq.com/ldstore/htSRRd-1565875638264.png"
      },
      {
        name: "斗法天地",
        id: 420,
        icon_url: "https://img.ldmnq.com/ldstore/iQ8R7W-1569227728504.png"
      },
      {
        name: "大秦黎明",
        id: 458,
        icon_url: "https://img.ldmnq.com/ldstore/aQxQYW-1567991591738.png"
      },
      {
        name: "超神",
        id: 429,
        icon_url: "https://img.ldmnq.com/ldstore/AYkrSW-1566388840875.png"
      },
      {
        name: "部落冲突",
        id: 61,
        icon_url:
          "https://img.ldmnq.com/ldstore/JJY4RQ2R5tCeDpi8PRfnMxEJyXHyrnHx.png"
      },
      {
        name: "犬夜叉奈落之战",
        id: 462,
        icon_url: "https://img.ldmnq.com/ldstore/4RxNZy-1568702049525.png"
      },
      {
        name: "长城",
        id: 472,
        icon_url: "https://img.ldmnq.com/ldstore/SaWT4A-1568773932112.png"
      },
      {
        name: "空之轨迹",
        id: 470,
        icon_url: "https://img.ldmnq.com/ldstore/S2JTCN-1568701887923.png"
      },
      {
        name: "辐射：避难所Online",
        id: 277,
        icon_url: "https://img.ldmnq.com/ldstore/ndST6n-1561034375150.png"
      },
      {
        name: "圣天使战歌",
        id: 493,
        icon_url: "https://img.ldmnq.com/ldstore/QSGKHy-1568629282326.png"
      },
      {
        name: "轩辕剑3手游版",
        id: 496,
        icon_url: "https://img.ldmnq.com/ldstore/raNGWe-1568183761010.png"
      }
    ],
    gameid: null
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    },
    games: function() {
      let gamelist = JSON.parse(JSON.stringify(this.gamelist));
      return this.from === "signin" ? gamelist : gamelist.splice(1);
    }
  },
  methods: {
    changeGameID(id) {
      if(this.gameid===id){
        this.gameid=0;
        return;
      }
      this.gameid = id;
    },
    async handleGetDiscount() {
      if (!this.gameid) {
        this.$toast({
          type: "fail",
          message: "请选择一款游戏代金券",
          duration: 1200,
          position: "middle"
        });
        return;
      }
      if (this.from === "draw") {
        let { data } = await this.$api.activity.drawDiscount({
          drawId: this.prize.id || this.prize.drawId,
          gameId: this.gameid
        });
        let that = this;
        let msg = {
          type: data.code === 0 ? 'success' : 'fail', 
          message: data.code === 0 ? '领取成功' : data.msg, 
          duration: 1200,
          position: "middle",
          onOpened: function() {
            if(data.code === 0){
              that.$parent.open("showGames");
            }
          }
        };
        this.$toast(msg)
      }
      if (this.from === "buy") {
        let { data } = await this.$api.activity.getDiscount({
          vid: this.prize.id,
          address: `${this.gameid}`
        });
        let that=this;
        let msg = {
          type: data.code === 0 ? 'success' : 'fail', 
          message: data.code === 0 ? '领取成功' : data.msg, 
          duration: 1200,
          position: "middle",
          onOpened: function() {
            if(data.code === 0){
              that.$parent.open("showGames");
            }
          }
        };
        this.$toast(msg)
      }
      if (this.from === "signin") {
        let { data } = await this.$api.activity.signin({
          address: this.gameid
        });
        let type = data.code === -1 ? "fail" : "success";
        let that = this;
        this.$toast({
          message: data.msg,
          duration: 1200,
          position: "middle",
          type,
          onOpened: function() {
            if (data.code === 0) {
              that.$emit('signin-success')
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.show-games {
  width: 745px;
  padding: 50px;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  border-radius: 30px;
  font-size: 45px;
  margin-bottom: 80px;
  text-align: center;
  .btn{
    cursor: pointer;
    border-radius: 50px;
    height: 100px;
    line-height: 100px;
  }
  .subhead {
    margin-top: 20px;
    font-size: 30px;
  }
  .list {
    height: 700px;
    overflow-y: scroll;
  }
  .name {
    font-size: 30px;
    margin-bottom: 20px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .input {
    border-radius: 50%;
    margin: 0 auto;
    display: block;
    box-sizing: border-box;
    width: 1.25em;
    height: 1.25em;
    color: transparent;
    font-size: 0.8em;
    line-height: inherit;
    text-align: center;
    border: 1px solid #737373;
    transition: 0.2s;
    font-style: normal;
  }
  .inputSuccess {
    color: #fff;
    background: linear-gradient(to bottom, #e28215, #dc580d);
    border-color: #dc580d;
  }
  .inputSuccess:before {
    content: "√";
  }
}
.mt {
  margin-bottom: 40px;
}
.mt1 {
  margin-bottom: 5px;
}
.mt2 {
  margin-bottom: 15px;
}
.cancel {
  cursor: pointer;
  margin: 0 auto;
  height: 60px;
  width: 60px;
  background: url("../assets/guanbi-min.png") no-repeat;
  background-size: 100% 100%;
}
</style>